
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/design-system/done",
      function () {
        return require("private-next-pages/download/design-system/done/index.tsx");
      }
    ]);
  